import Highlight from 'components/common/Highlight';
import { useFormik } from 'formik';
import { Box, Button, FormField, Text, TextInput } from 'grommet';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import BounceLoader from 'react-spinners/BounceLoader';
import { dispatchAction } from 'rxbeach';
import { take, tap } from 'rxjs/operators';
import { State } from 'types';
import { object, ref, string } from 'yup';
import { reset } from '../stream/actions';
import { auth$ } from '../stream/auth$';

const validationSchema = object({
  password: string().min(5).required('Sikkeret er viktig'),
  password2: string()
    .required('🙀')
    .oneOf([ref('password')], 'Passordene må matche'),
});

interface ResetProps {
  state?: State;
  toLogin?: Function;
}

const Reset = ({ state }: ResetProps) => {
  const navigate = useNavigate();
  const { nonce, email } = useParams()
  const { touched, values, errors, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: {
        password: '',
        password2: '',
      },
      validationSchema,
      onSubmit: ({ password }) => {
        if (typeof nonce !== 'string' || typeof email !== 'string') return;
        dispatchAction(reset({ password, email, nonce }));
        auth$
          .pipe(
            take(2),
            tap(({ state }) => {
              if (state === State.SUCCESS) {
                navigate('/');
              }
            })
          )
          .subscribe();
      },
    });

  const loading = state === State.LOADING;

  return (
    <Box fill align="center" justify="center" pad="large">
      <Box width="medium" gap="medium">
        <Text size="xlarge" weight="bold">
          Lag et nytt passord
        </Text>
        <FormField
          label="Passord"
          error={touched.password && errors.password}
          required
        >
          <TextInput
            id="password"
            type="password"
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </FormField>

        <FormField
          label="Bekreft Passord"
          error={touched.password2 && errors.password2}
          required
        >
          <TextInput
            id="password2"
            type="password"
            value={values.password2}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </FormField>

        {state === State.ERROR && (
          <Highlight danger message="Det skjedde noe uventa" />
        )}

        <Box direction="row" gap="small" margin={{ top: 'medium' }}>
          <Button
            label="Submit"
            disabled={loading}
            primary
            onClick={() => handleSubmit()}
          />
          {loading && <BounceLoader size={40} color="#7D4CDB" loading={true} />}
        </Box>
      </Box>
    </Box>
  );
};

export default Reset;
